import type { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/components/ui/tooltip';
import { cn } from 'src/lib/utils';
import { REACH_APPROXIMATE_TOOLTIP } from '../utils/reach-metric.utils';

type ApproximateMetricMarkerProps = {
  tooltip?: string;
  variant?: 'beta' | 'legacy';
  className?: string;
  children?: ReactNode;
};

export function ApproximateMetricMarker({
  tooltip = REACH_APPROXIMATE_TOOLTIP,
  variant = 'legacy',
  className,
  children,
}: ApproximateMetricMarkerProps) {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              'inline-flex items-baseline gap-1 cursor-help',
              variant === 'beta'
                ? 'border-b border-dashed border-white/60'
                : 'border-b border-dashed border-gray-500',
              className,
            )}
            aria-label={tooltip}
          >
            {children}
            <span
              className={cn(
                'text-[0.85em] font-semibold leading-none',
                variant === 'beta' ? 'text-white/90' : 'text-gray-600',
              )}
            >
              ~
            </span>
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs text-sm">
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
